<template>
<div class="action-flow-node action-flow-node-danger" style="height: 240px;">
	<div class="action-flow-title">Create Mote</div>
	<div class="action-flow-hint">Create a single mote of data from data provided and save it.</div>
	
	<ActionParamHint label="Blueprint" hint="Type of mote to create." param-class="param-config" 
		param-input-type="text"  param-input-label="Blueprint type" @param-change="handleParamChange"
		:param-input-value="parameters.blueprint"
	/>
	<ActionParamHint label="Imported Flag" hint="If this mote should be marked as an imported mote (not considered a real mote until validated)." param-class="param-config"
		param-input-type="select" param-input-label="Imported?" @param-change="handleParamChange"
		:param-input-options="[{ value: 'true', label: 'Mark as Imported' }, { value: 'false', label: 'Mark as Normal' }]"
		:param-input-value="parameters.imported ? 'true' : 'false'"
	/>
	<ActionParamHint label="Data" hint="Field values to submit to the creation. You can feed in objects to this input to use them in the message format." param-class="param-tgt" 
		param-input-type="textarea" param-input-label="Field values" @param-change="handleParamChange"
		:param-input-value="parameters.data"
	/>
	<ActionParamHint label="Created" hint="The newly created mote after saving." param-class="param-src" />
	
	<Handle type="target" id="tgt-data" :position="Position.Left" style="top: 175px;" />
	<Handle type="source" id="src-created" :position="Position.Right" style="top: 215px;" />
</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	blueprint: '',
	imported: false,
	data: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			blueprint: newNodeData.data?.blueprint || '',
			imported: Boolean(newNodeData.data?.imported || false),
			data: newNodeData.data?.data || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	switch (paramData.label.toLowerCase()) {
		case 'blueprint':
			parameters.value.blueprint = paramData.value;
			break;
		case 'imported flag':
			parameters.value.imported = paramData.value === 'true'
			break;
		case 'data':
			parameters.value.data = paramData.value;
			break;
		default:
			console.error(`Unknown parameter label: ${paramData.label}`);
			return;
	}
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>

